import { FC, MouseEvent } from "react";
import CardFooter from "./footer/card-footer";
import CourseTag from "./badge";
import CardTitle from "./card-title";
import CardInstructor from "./card-instracture";
import CardDuration from "./card-duration";
import classNames from "classnames";
import CardProduct from "./card-product";
import BadgeCoupon from "./badge-coupon";
import Link from "next/link";
import { CARD_TAG, CARD_VARIANT, ICard } from "./types";
import { useCardAction } from "./useCartAction";

const CardBody: FC<
  ICard & {
    isFestival?: boolean;
    hugElement?: boolean;
    href: string;
    showCardFooter?: boolean;
  }
> = ({
  title,
  instructor,
  duration,
  variant,
  isBuy,
  price,
  watchPercent,
  status,
  showDetail = true,
  showTag = false,
  showTeacher = true,
  showTime = true,
  id,
  submitRate,
  festival,
  festival_new,
  hugElement = false,
  inCart,
  sku,
  tag,
  showCardFooter = true,
  hasCertificate,
  totalOrders,
  title_short,
  details_expire,
  showShoppingCart = false,
  renderSubscriptionFooter,
  notFullyClickable,
  href,
  linkTarget,
  slug,
  type,
}) => {
  const { openCouponModal } = useCardAction();

  const openCouponModalHandler = () => {
    openCouponModal({
      id: id,
      price: price as number,
      sku: sku,
      title: title,
      expire: details_expire,
      slug: slug,
      type: type,
    });
  };

  const linkClickHandler = (e: MouseEvent<HTMLAnchorElement>) => {
    if (details_expire?.can_purchase) {
      e.preventDefault();
      e.stopPropagation();
      openCouponModalHandler();
    }
  };

  const isGrid = variant === CARD_VARIANT.GRID;
  return (
    <div className="flex w-full flex-col">
      {notFullyClickable ? (
        <Link
          href={href}
          prefetch={false}
          target={linkTarget || "_self"}
          draggable={false}
          onClick={linkClickHandler}
        >
          <CardTitle hugElement={hugElement} title={title_short || title} />
        </Link>
      ) : (
        <CardTitle hugElement={hugElement} title={title_short || title} />
      )}

      {showTag && (
        <div className="h-4 md:h-5 mb-1 sm:mb-1.5">
          {tag ? <CourseTag type={tag as CARD_TAG} /> : <br />}
        </div>
      )}
      <div className={classNames("flex-col", showDetail ? "flex" : "hidden")}>
        <CardProduct productCount={totalOrders || 0} hugElement={hugElement} />

        <CardInstructor
          instructor={instructor}
          hugElement={hugElement}
          showTeacher={showTeacher || false}
        />
        <CardDuration
          duration={duration}
          showTime={showTime || false}
          hugElement={hugElement}
        />
      </div>
      {showCardFooter ? (
        <CardFooter
          isBuy={isBuy}
          status={status}
          price={price}
          watchPercent={watchPercent}
          submitRate={submitRate}
          id={id}
          festival={festival_new || festival}
          showShoppingCart={isGrid || showShoppingCart}
          variant={variant}
          inCart={inCart}
          sku={sku || ""}
          hasCertificate={hasCertificate}
          renderSubscriptionFooter={renderSubscriptionFooter}
        />
      ) : null}
      {details_expire && <BadgeCoupon details_expire={details_expire} />}
    </div>
  );
};
export default CardBody;
